<template>
  <div class="nft_list">
    <div>
      <div v-if="isConnected && nfts.length > 0" class="px-2 md:px-0">
        <div
          class="flex flex-col flex-wrap md:flex-row md:-mx-3 md:justify-start items-start mt-6 text-center"
        >
          <div
            class="md:w-1/4 w-4/5 p-3 md:px-3"
            v-for="nft in nfts"
            :key="nft.nft_id"
            v-on:click="clickNFT(nft.contract, nft.player_id)"
          >   
            <NFT :contract="nft.contract" :id="nft.player_id" :nft="nft" :playPage="true" />
          </div>
        </div>
      </div>
      <div v-else class="text-center text-2xl mt-10 font-light">
        You don't have any pets yet.
        </br>Register one of your NFTs as pets to play in the game. You DO NOT lose your NFT if you lose in the game. 
      </div>
    </div>

    <ConnectWallet />
  </div>
</template>

<script>
import ConnectWallet from "@/components/ConnectWallet.vue";
import NFT from "@/components/NFT.vue";
import axios from "axios";
export default {
  name: "NFTList",
  components: { ConnectWallet, NFT },
  data: function () {
    return {
      nfts: [],
      isLoading: true,
      listSize: 0,
      onClicked: Function,
      showTable: false,
      nftsCanMine: [],
      loader: null,
      gems: [],
      hasTokenApproval: false,
    };
  },
  methods: {
    clickNFT: function (contract, id) {
      console.log("click");
      this.$emit("NFTClick", contract, id);
    },
    fetchNFTS: async function () {
      if (this.$store.state.web3 == null) {
        return;
      }
      console.log(this.$store.state.account);

      const result = await axios.get(
        `https://api.nft20.io/game/user/${this.$store.state.account.toLowerCase()}`
      );

      console.log("nfts ", result.data);
      this.nfts = result.data;

      // let expectedTokens = (this.listSize = await this.$store.state.GameContract.methods
      //   .getInfo(1)
      //   .call());

      // console.log("expectedTokens ", expectedTokens);
      // this.listSize = await this.$store.state.GameContract.methods
      //   .balanceOf(this.$store.state.account)
      //   .call();
      // let tokens = [];
      // for (let index = 0; index < this.listSize; index++) {
      //   console.log(index);
      //   let id = await this.$store.state.GameContract.methods
      //     .playersOfAddressByIndex(this.$store.state.account, index)
      //     .call();
      //   tokens.push({
      //     id: id,
      //     contract: this.$store.state.account.toLowerCase(),
      //   });
      // }
      // this.nfts = tokens;
    },

    approve: async function () {
      let max =
        "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      let remove = "0";
      let approve = await this.$store.state.MuseTokenContract.methods
        .approve(this.$store.state.contracts.MultiVnft, max)
        .send({
          from: this.$store.state.account,
        });
    },
    init: async function () {
      this.hasTokenApproval =
        (
          await this.$store.state.MuseTokenContract.methods
            .allowance(
              this.$store.state.account,
              this.$store.state.contracts.MultiVnft
            )
            .call()
        ).length >= 18;

      console.log("token approval", this.hasTokenApproval);
    },
  },
  mounted: function () {
    this.init();
  },
  beforeMount: function () {
    this.fetchNFTS();
  },
  watch: {
    isConnected: function () {
      this.fetchNFTS();
      this.init();
    },
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
